import React, { useEffect, useState, useContext } from "react";
import { get, post } from "../../api";
import { AuthContext } from "../../contexts/Auth";
import Frame from "../../components/Frame";
import FrameHeader from "../../components/FrameHeader";
import Button from "../../components/Button";
import InputRow from "../../components/InputRow";
import LoadingFrame from "../../components/LoadingFrame";
import { useConfirm } from "material-ui-confirm";
import Modal from "../../components/Modal";
import Space from "../../components/Space";
import Icon from "../../components/Icon";
import styles from "./NewSubscription.module.scss";
import "react-credit-cards/es/styles-compiled.css";
import { useMediaQuery } from "react-responsive";
import PaymentProfile from "../../components/PaymentProfile/PaymentProfile";
import Label from "../../components/Label";
import SalesRepresentativeBanner from "../../components/SalesRepresentativeBanner/SalesRepresentativeBanner";
export default function NewSubscription({
  match: { params },
  location: { search },
  singleSelect = false,
  device,
  onClose,
  onRefresh,
}) {
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const confirm = useConfirm();
  const { state: currentUser } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [customer_modified, setCustomerModified] = useState(null);
  const [paymentInProgress, setPaymentInProgress] = useState(false);
  const [generatingCheckout, setGeneratingCheckout] = useState(false);

  const [expiredDevices, setExpiredDevices] = useState(0);
  const [error, setError] = useState(null);
  const [subscriptions, setSubscriptions] = useState({
    fiveYear: { quantity: 0 },
    threeYear: { quantity: 0 },
    oneYear: { quantity: 0 },
  });

  const [cart, setCart] = useState([]);
  const INFO_STEP = 0;
  const CHECKOUT_STEP = 1;
  const PAYMENT_SUCCESS = 2;
  const [step, setStep] = useState(INFO_STEP);
  const [orderNumber, setOrderNumber] = useState(null);
  const [paymentProfile, setPaymentProfile] = useState(null);

  const getCustomerProfile = async () => {
    const customerProfile = await Promise.all([
      get(`/customers/${currentUser.user.customer_id}`),
    ]);
    customerProfile && setCustomer(customerProfile?.[0]);
  };

  const getCustomerPaymentProfile = async () => {
    const customerPaymentProfile = await Promise.all([
      get(`/customers/paymentprofile`),
    ]);

    customerPaymentProfile &&
      customerPaymentProfile[0] &&
      customerPaymentProfile[0]?.length > 0 &&
      setPaymentProfile(customerPaymentProfile[0]);
  };

  const retrieveCustomerExpiredDevices = async () => {
    setLoading(true);
    await getCustomerProfile();
    const devices = await get(`/customers/subscriptions/expired`);
    if (devices) {
      setExpiredDevices(devices);
    }
    await getCustomerPaymentProfile();
    setLoading(false);
  };

  useEffect(() => {
    retrieveCustomerExpiredDevices();
  }, []);

  const handleAddToCart = (option) => {
    let price = 240;
    console.log("device", device);
    switch (option) {
      case "oneYear":
        break;
      case "threeYear":
        price = 648;
        break;
      case "fiveYear":
        price = 900;
        break;
    }
    if (singleSelect) {
      const newItem = {
        option,
        quantity: 1,
        price,
        serial_number: device?.serial_number, // Include serial number if available
      };
      setCart([newItem]);
      return newItem;
    }
    setCart((currentCart) => {
      const existingItemIndex = currentCart?.findIndex(
        (item) => item.option === option
      );

      if (existingItemIndex >= 0) {
        const updatedCart = [...currentCart];
        updatedCart[existingItemIndex] = {
          ...updatedCart[existingItemIndex],
          quantity: updatedCart[existingItemIndex].quantity + 1,
        };
        return updatedCart;
      } else {
        const newItem = {
          option: option,
          quantity: 1,
          price: price,
          serial_number: device?.serial_number, // Include serial number if available
        };
        return [...currentCart, newItem];
      }
    });

    setSubscriptions((currentSubscriptions) => ({
      ...currentSubscriptions,
      [option]: { ...currentSubscriptions[option], quantity: 0 },
    }));
  };

  function validated() {
    switch (step) {
      case INFO_STEP:
        return !cart?.length == 0;
        break;

      case CHECKOUT_STEP:
        return paymentProfile != null && !generatingCheckout;
        break;

      case PAYMENT_SUCCESS:
        return true;
    }
  }

  async function placeOrder() {
    try {
      setPaymentInProgress(true);
      const checkoutGenerate = await post("/checkout/generate", {
        customer: customer_modified || customer,
        cart,
        device_id: device?.id,
      });

      if (!checkoutGenerate || !checkoutGenerate.cartId) {
        confirm({
          description:
            "Looks like something went wrong with the payment process. Contact the Sentinel support team to troubleshoot this issue. Call 949-361-5663 or e-mail sentinelsupport@traffixdevices.com.",
          title: "Unable to place order",
          dialogProps: { fullScreen: false },
          cancellationButtonProps: { style: { display: "none" } },
          confirmationButtonProps: { color: "primary", disableRipple: true },
        });
        setGeneratingCheckout(false);
      }
      const generatedCartId = checkoutGenerate.cartId;

      const res = await post("/checkout/placeorder", {
        cartId: generatedCartId,
        customer_id: customer.id,
        cart,
        device_id: device?.id,
      });
      if (res) {
        if (res.success) {
          setStep(PAYMENT_SUCCESS);
          onRefresh && onRefresh();
          setOrderNumber(res.content);
          setGeneratingCheckout(false);
        }
        if (res.error) {
          setError(res.content);
          confirm({
            description:
              "Looks like something went wrong with the payment process. Contact the Sentinel support team to troubleshoot this issue. Call 949-361-5663 or e-mail sentinelsupport@traffixdevices.com.",
            title: "Unable to place order",
            dialogProps: { fullScreen: false },
            cancellationButtonProps: { style: { display: "none" } },
            confirmationButtonProps: { color: "primary", disableRipple: true },
          })
            .then(() => {
              onClose && onClose();
            })
            .catch(() => {
              /* ... */
            });
        }
      }
      setPaymentInProgress(false);
    } catch (e) {
      console.log(e);
      setError(e?.message || "An error occurred during placing order");
      setPaymentInProgress(false);
    }
  }

  function displayCartItems() {
    if (cart?.length > 0) {
      const totalCost = cart.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
      return (
        <>
          <div className={styles.containerOverlay}>
            <div>
              <div className={styles.cartFrame}>
                {cart.map((item, index) =>
                  isMobile ? (
                    <div key={index} className={styles.quantitycontrolMobile}>
                      <div className={styles.minwidth}>
                        {decodeOptionShort(item.option)}
                      </div>
                      <div className={styles.totalcart}>
                        <div className={styles.quantitycontrol}>
                          <span className={styles.span}>
                            <p> {item.quantity}</p>
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div key={index} className={styles.cartItem}>
                      {decodeOptionShort(item.option)}
                      <div className={styles.totalcart}>
                        <div className={styles.quantitycontrol}>
                          <span className={styles.span_small}>
                            <p>Qty: {item.quantity}</p>
                          </span>
                        </div>
                      </div>
                      <span className={styles.span_price}>
                        <b> ${item.price * item.quantity}.00</b>
                      </span>
                    </div>
                  )
                )}
              </div>
              <div className={styles.priceRight}>
                <span className={styles.span_price}>
                  Total: <b> ${totalCost}.00</b>
                </span>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return "Cart empty";
    }
  }

  function subOption(label, color, onAddToCart, price) {
    const selected = cart?.findIndex((item) => item.price === price) >= 0;
    return (
      <div
        className={styles.label}
        onClick={onAddToCart}
        style={{ cursor: "pointer" }}
      >
        <div className={styles.img}>
          <div>
            <Icon
              color={color}
              name={"calendar_month"}
              size={isMobile ? 32 : 56}
            />
          </div>
        </div>
        <div className={styles.ceter}>
          <div className={styles.flexRow}>
            <div className={styles.text}>{label}</div>
          </div>
          <div className={styles.flexRow}>
            <div className={styles.sub_text}></div>
          </div>

          <div>
            <div className={styles.flexRow}>
              <div className={styles.center}>
                <p style={{ color: color }}>
                  <b>${price}</b>
                </p>
              </div>
            </div>
            <Space size="xs" />
            <div className={styles.wrap}>
              {singleSelect && selected ? (
                <Button size={isMobile ? "mobile" : "s"} theme={"orange"}>
                  Selected
                </Button>
              ) : (
                <Button
                  size={isMobile ? "mobile" : "s"}
                  theme={"primary"}
                  onClick={onAddToCart}
                >
                  {singleSelect ? "Select" : "Add to cart"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  function stepBack() {
    switch (step) {
      case INFO_STEP:
        confirm({
          description: "Are you sure you want to cancel?",
          title: null,
          dialogProps: { fullScreen: false },
          cancellationButtonProps: { color: "error", disableRipple: true },
          confirmationButtonProps: { color: "primary", disableRipple: true },
        })
          .then(() => {
            onClose ? onClose() : window.location.replace("/subscription");
          })
          .catch(() => {
            /* ... */
          });

        break;
      case CHECKOUT_STEP:
        setStep(step - 1);
        break;
    }
  }

  const NextStep = () => {
    switch (step) {
      case INFO_STEP:
        if (!paymentProfile) {
          confirm({
            description: "Please add a payment method to continue",
            title: null,
            dialogProps: { fullScreen: false },
            cancellationButtonProps: { color: "error", disableRipple: true },
            confirmationButtonProps: { color: "primary", disableRipple: true },
          })
            .then(() => {
              //window.location.replace("/subscription");
              // onClose ? onClose() : window.location.replace("/subscription");
            })
            .catch(() => {
              /* ... */
            });
        } else {
          setStep(CHECKOUT_STEP);
        }
        break;
      case CHECKOUT_STEP:
        setPaymentInProgress(true);
        placeOrder();

        break;

      case PAYMENT_SUCCESS:
        onClose ? onClose() : window.location.replace("/subscription");
        break;
    }
  };

  const returnIconWrapper = (color, text) => {
    return (
      <div className={styles.flexContainer}>
        <div className={styles.iconContainer}>
          <Icon color={color} name={"calendar_month"} size={36} />
        </div>
        <div className={styles.textContainer}>{text}</div>
      </div>
    );
  };

  const decodeOptionShort = (option) => {
    if (!isMobile) {
      switch (option) {
        case "oneYear":
          return returnIconWrapper("#ee0e0e", "1 Year Subscription");
        case "threeYear":
          return returnIconWrapper("#f26925", "3 Year Subscription");
        case "fiveYear":
          return returnIconWrapper("#05b008", "5 Year Subscription");
      }
    } else {
      switch (option) {
        case "oneYear":
          return "1 Year";
        case "threeYear":
          return "#f26925", "3 Year";
        case "fiveYear":
          return "#05b008", "5 Year";
      }
    }
  };

  function renderContent() {
    switch (step) {
      case INFO_STEP:
        return (
          <>
            <SalesRepresentativeBanner />
            <FrameHeader title="Subscription details" />
            <Frame>
              <Space>
                <p>
                  Please choose a subscription length to maintain active asset
                  monitoring.
                </p>
              </Space>

              <div className={styles.center}>
                <InputRow>
                  <div className={styles.wrap2}>
                    {subOption(
                      "5 Year Subscription",

                      "#05b008",
                      () => handleAddToCart("fiveYear"),
                      900
                    )}
                    {subOption(
                      "3 Year Subscription",

                      "#f26925",
                      () => handleAddToCart("threeYear"),
                      648
                    )}
                    {subOption(
                      "1 Year Subscription",

                      "#ee0e0e",
                      () => handleAddToCart("oneYear"),
                      240
                    )}
                  </div>
                </InputRow>
              </div>
            </Frame>
            <Space />
            {!loading && !paymentProfile && (
              <PaymentProfile
                closeAddModal={() => {}}
                onRefresh={() => {
                  getCustomerPaymentProfile();
                }}
              />
            )}
          </>
        );

      case CHECKOUT_STEP:
        return (
          <>
            <PaymentProfile editEnabled={false} />

            <Space size="xs" />
            {device && (
              <>
                <FrameHeader title="Device" />
                <Frame>
                  <Label text="Serial number" theme={"light"}>
                    <b>{device?.serial_number}</b>
                  </Label>
                </Frame>
                <Space size="xs" />
              </>
            )}

            <FrameHeader title="Order summary" />
            <Frame>{displayCartItems()}</Frame>
          </>
        );

      case PAYMENT_SUCCESS:
        return (
          <div className={styles.parent}>
            <div className={styles.child}>
              <Frame simple={true}>
                <Space>
                  <div className={styles.wrap}>
                    <div className={styles.icon}>
                      <Icon name="check_circle" size={isMobile ? 36 : 56} />
                    </div>
                    <div className={styles.wrapvert}>
                      <h1>Thank you for your purchase</h1>
                    </div>
                    <p className={styles.bodyLeft}>
                      Your order number is: <b>000000{orderNumber}</b>. An Order
                      Confirmation email has been sent to you.
                    </p>
                  </div>
                </Space>
              </Frame>
              <Space />
              {singleSelect ? (
                <Frame>
                  <div className={styles.centered}>
                    Asset monitoring is now active.
                  </div>
                </Frame>
              ) : (
                <Frame>
                  <div className={styles.wrap}>
                    {displaySubscriptionWizardOptions()}
                  </div>
                </Frame>
              )}
            </div>
          </div>
        );
    }
  }

  const displaySubscriptionWizardOptions = () => {
    return expiredDevices > 0 ? (
      <>
        <p className={styles.bodyLeft}>
          There{" "}
          {expiredDevices == 1 ? (
            <>
              is <b>{expiredDevices}</b> expired device.
            </>
          ) : (
            <>
              are <b>{expiredDevices}</b> expired devices.
            </>
          )}
        </p>
        <Space />
        <div className={styles.wrap}>
          Open the subscription wizard to manage subscriptions.
          <Space />
          <Button
            theme="primary"
            icon="auto_fix_normal"
            noHeight={true}
            onClick={() =>
              window.location.replace("/subscriptions?assign=true")
            }
          >
            Subscription wizard
          </Button>
        </div>
      </>
    ) : (
      <div className={styles.wrap}>
        <p>
          There are no devices that are expired or expiring. Press <b>Finish</b>{" "}
          to continue.
        </p>
      </div>
    );
  };

  function _renderFooter() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "16px",
        }}
      >
        {step !== PAYMENT_SUCCESS && (
          <Button
            disabled={loading || paymentInProgress}
            onClick={() => stepBack()}
          >
            {step === 0 ? "Cancel" : "Back"}
          </Button>
        )}
        <Button
          theme="primary"
          onClick={NextStep}
          isLoading={loading || paymentInProgress}
          disabled={!validated()}
        >
          {step === INFO_STEP && "Checkout"}
          {step === CHECKOUT_STEP && "Place Order"}
          {step === PAYMENT_SUCCESS && "Finish"}
        </Button>
      </div>
    );
  }

  return (
    <Modal isLoading={paymentInProgress} footer={_renderFooter()}>
      {renderContent()}
    </Modal>
  );
}
